(()=>{
const root=document.getElementById('menu-drawer');
if(!root||root.dataset.vacdraFoldReady)return;
root.dataset.vacdraFoldReady='true';
const nav=root.querySelector('.menu-drawer__navigation');
const list=nav&&nav.querySelector(':scope > .menu-drawer__menu');
if(!list)return;
const rows=Array.from(list.children);
rows.forEach((row,index)=>row.style.setProperty('--vacdra-line-index',index));
const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
let frame=0,resetTimer=0,selecting=false;
const reset=()=>{
if(selecting)return;
cancelAnimationFrame(frame);
rows.forEach(row=>{row.classList.remove('vacdra-fold-current');row.style.removeProperty('--vacdra-fold-angle');row.style.removeProperty('--vacdra-fold-y');row.style.removeProperty('--vacdra-fold-z');});
};
const fold=index=>{
if(motion.matches||selecting)return;
clearTimeout(resetTimer);
const selected=rows[index];
const column=rows.filter(row=>Math.abs(row.offsetLeft-selected.offsetLeft)<2);
const position=column.indexOf(selected);
column.forEach((row,i)=>{
const distance=i-position,near=Math.abs(distance)<=2;
row.classList.toggle('vacdra-fold-current',row===selected);
row.style.setProperty('--vacdra-fold-angle',near?(distance===0?-3:distance<0?-Math.max(2,9-Math.abs(distance)*2):Math.max(2,7-distance*2))+'deg':'0deg');
row.style.setProperty('--vacdra-fold-y',near?(distance===0?-1:distance<0?-2:1)+'px':'0px');
row.style.setProperty('--vacdra-fold-z',distance===0?'8px':near?'-3px':'0px');
});
};
const track=(x,y)=>{
if(motion.matches||selecting)return;
cancelAnimationFrame(frame);
frame=requestAnimationFrame(()=>{
let nearest=-1;
rows.forEach((row,i)=>{const bounds=row.getBoundingClientRect();if(x>=bounds.left&&x<=bounds.right&&y>=bounds.top&&y<=bounds.bottom)nearest=i;});
if(nearest>=0)fold(nearest);
});
};
list.addEventListener('pointermove',event=>{if(event.pointerType!=='touch')track(event.clientX,event.clientY);},{passive:true});
list.addEventListener('touchmove',event=>{if(event.touches.length===1)track(event.touches[0].clientX,event.touches[0].clientY);},{passive:true});
list.addEventListener('touchstart',event=>{if(event.touches.length===1)track(event.touches[0].clientX,event.touches[0].clientY);},{passive:true});
list.addEventListener('pointerleave',()=>{resetTimer=setTimeout(reset,100);});
list.addEventListener('touchend',()=>{resetTimer=setTimeout(reset,180);},{passive:true});
list.addEventListener('touchcancel',reset,{passive:true});
list.addEventListener('focusin',event=>{const index=rows.findIndex(row=>row.contains(event.target));if(index>=0)fold(index);});
list.addEventListener('focusout',event=>{if(!list.contains(event.relatedTarget))reset();});
list.addEventListener('click',event=>{
const link=event.target.closest('a[href]');
if(!link||motion.matches||event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||link.target||link.hasAttribute('download'))return;
const destination=new URL(link.href,window.location.href);
if(destination.origin!==window.location.origin)return;
const row=rows.find(item=>item.contains(link));
if(!row)return;
event.preventDefault();
if(selecting)return;
selecting=true;
root.classList.add('vacdra-menu-selecting');
row.classList.add('vacdra-fold-selected');
window.setTimeout(()=>window.location.assign(destination.href),175);
});
window.addEventListener('pageshow',()=>{selecting=false;root.classList.remove('vacdra-menu-selecting');rows.forEach(row=>row.classList.remove('vacdra-fold-selected'));reset();});
const details=root.closest('details');
if(details)details.addEventListener('toggle',()=>{if(!details.open){selecting=false;root.classList.remove('vacdra-menu-selecting');rows.forEach(row=>row.classList.remove('vacdra-fold-selected'));reset();}});
})();